// extracted by mini-css-extract-plugin
module.exports = {"input-text":"input-text_input-text__2E4eK","error":"input-text_error__2Q7ji"};